// Typed API error — carries a machine-readable code + HTTP status.
// Used by serverFetch and all service modules.

export type ApiErrorCode =
  | 'unauthorized'
  | 'forbidden'
  | 'not_found'
  | 'validation_error'
  | 'conflict'
  | 'plan_required'
  | 'network_error'
  | 'server_error'
  | 'unknown'

export class ApiError extends Error {
  constructor(
    public readonly code: ApiErrorCode,
    message: string,
    public readonly status?: number,
    /**
     * The `error` object from the response body, when it carried one beyond
     * `code` and `message`.
     *
     * Some refusals are only actionable with their detail: a stock write
     * refused for dropping below what diners already ordered names the dates,
     * and a merchant told "conflict" without them cannot fix it. Unparsed on
     * purpose — the shape is per route, and the caller that knows the route
     * narrows it.
     */
    public readonly details?: Record<string, unknown>
  ) {
    super(message)
    this.name = 'ApiError'
  }
}
